import i18n from '../i18n';
import { getCountryCurrency } from './helpers';
import { getCountry } from '../component-helpers/common';

// These options are needed to round to whole numbers if that's what you want.
//minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
//maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
export function getCurrencyFormatter(countryCode: CountryCode, opt: Intl.NumberFormatOptions = {}): Intl.NumberFormat {
  const languageTag = i18n.language;
  const currency = getCountryCurrency(countryCode);
  return new Intl.NumberFormat(languageTag, {
    style: 'currency',
    currency,
    ...opt,
  });
}

export const formattedAmount = (amount: number, countryCode: CountryCode): string => {
  const formatter = getCurrencyFormatter(countryCode);
  // Make sure to also support zero-decimal currencies : https://stripe.com/docs/currencies#zero-decimal
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/formatToParts
  // https://dev.to/stripe/type-safe-payments-with-next-js-typescript-and-stripe-4jo7#format-currencies-for-display-and-detect-zerodecimal-currencies
  const parts = formatter.formatToParts(amount);
  let zeroDecimalCurrency: boolean = true;
  for (let part of parts) {
    if (part.type === 'decimal') {
      zeroDecimalCurrency = false;
    }
  }
  return formatter.format(zeroDecimalCurrency ? amount : amount / 100);
};

export const formatMeteredAmount = (amount: number, action: string, countryCode: CountryCode): string => {
  return `${formattedAmount(amount, countryCode)}/${action}`.trim();
};

export type FormattedCurrency = {
  long: string,
  short: string,
  amount: number
}

export const formatSubscriptionAmount = (amount: number, countryCode: CountryCode, prependCurrencyForUS?: boolean): FormattedCurrency => {
  const currencyCode = prependCurrencyForUS && getCountry().isUS ? getCountryCurrency(countryCode) : '',
    long = `${currencyCode} ${i18n.t('amount_per_month', { amount: formattedAmount(amount, countryCode) })}`.trim(),
    short = amount === 0 ? i18n.t('free') : `${i18n.t('amount_per_month_small', { amount: formattedAmount(amount, countryCode) })}`;

  return {
    long, short, amount,
  };
};